// ─────────────────────────────────────────────────────────────
// Forfaits ménage de sortie (pulizia di USCITA : à la partenza degli ospiti).
// Les prix se changent ICI, ils se répercutent partout
// (Gestione Prenotazioni : tableau + stats, Gestione Pulizie : cartes).
// ─────────────────────────────────────────────────────────────

export const CLEANING_PACKAGES = [
  { value: 'completo_cambio_intermedio', label: 'Completo + cambio biancheria intermedio', shortLabel: 'Completo + intermedio', price: 220 },
  { value: 'completo', label: 'Completo', shortLabel: 'Completo', price: 180 },
  { value: 'cambio_verifica', label: 'Cambio biancheria + verifica', shortLabel: 'Cambio + verifica', price: 60 },
  { value: 'cambio', label: 'Cambio biancheria', shortLabel: 'Cambio', price: 40 },
];

export const cleaningPackageForValue = (value) =>
  CLEANING_PACKAGES.find((pkg) => pkg.value === value) || null;
